<template>
    <div class="text-input">
        <div @click="closeList()" v-if="open" class="dropdown-background"></div>
        <label><b>{{label}}</b></label>
        <div class="input-group">
            
            <!-- <select class="form-control"
                    :placeholder="placeholder"
                    v-model="displayValue"
                    @change="updateSalesRep"
                    :disabled="disabled"
                    :aria-label="{label}">
                
                <option v-for="(pm, index) in salesReps"
                        :key="pm.SalesRepId"
                        :value="pm.SalesRepId">{{ pm.FirstName }} {{ pm.LastName }}</option>
            </select> -->

            <input class="form-control pr-4"
                    :placeholder="placeholder"
                    v-model="displayValue"
                    @focus="openList()"
                    ref="repSelect"
                    :disabled="disabled"
                    :aria-label="{label}"/>
                    
                 <i @click="focusAutoComplete()" class="fa fa-angle-down icon-dropdown"  aria-hidden="true"></i>
            <div v-if="open" class="rep-list-card card">
                <ul class="p-0 m-0">
                    <div class="pointer rep-list" v-for="pm in salesRepOptions" :key="pm.SalesRepId" @click="updateValue(pm)">{{ pm.FirstName }} {{ pm.LastName }}</div>
                </ul>
            </div>
            <!-- <i class="fa fa-chevron-down"></i> -->
        </div>
    </div>
</template>

<script>
    export default {
        name: "SalesRepSelect",
        props: {
            salesReps: {
                type: Array,
            },
            label: {
                type: String,
            },
            placeholder: {
                type: String,
            },
            value: {
                type: Number,
            },
            disabled: {
                type: Boolean,
                default: false,
            }
        },

        data(){
            return {
                displayValue: "",
                open: false
            }
        },  
        methods: {
            focusAutoComplete(){
                this.$refs.repSelect.focus()
            },
            openList(){
                this.displayValue = "";
                this.open = true;
            },
            closeList(){
                this.displayValue = this.getSalesRepFullName(this.value)
                this.open = false;
            },
            updateValue(SalesRep){
                this.displayValue = SalesRep.FirstName + " " + SalesRep.LastName;
                let salesRepId = Number(SalesRep.SalesRepId);
                this.$emit('input',salesRepId);
                this.closeList()
            },
            // updateSalesRep($event){
            //     console.log($event)
            //     let salesRepId = Number($event.target.value);
            //     this.$emit('input',salesRepId);
            // },
            getSalesRepFullName(id){
                if(id === null) return "";
                let index = this.salesReps.map(rep => rep.SalesRepId).indexOf(id)
                if(index < 0) return ""
                return this.salesReps[index].FirstName + " " + this.salesReps[index].LastName
            }
        },
        watch:{
            value: function(){
                this.displayValue = this.getSalesRepFullName(this.value);
            },
            salesReps: function(){
                this.displayValue = this.getSalesRepFullName(this.value);
            }
        },
        computed: {
            salesRepOptions(){
                let repOptions = this.salesReps.filter(rep => {
                    if(!rep.IsLockedOut && rep.IsUserActive) {
                        let fullName = rep.FirstName + " " + rep.LastName;
                        fullName = fullName.toLowerCase()
                        return fullName.includes(this.displayValue.toLowerCase())
                    }
                })
                return repOptions.sort(function(a, b) {
                    var textA = a.FirstName.toUpperCase();
                    var textB = b.FirstName.toUpperCase();
                    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                });
            }
        },
        created(){
            this.displayValue = this.getSalesRepFullName(this.value);
        }
    }
</script>

<style scoped lang="scss">
.icon-dropdown{
        position: absolute;
        right: 10px;
        top: 10px;
    }
    .rep-list-card{
        z-index: 15;
        margin-top: 40px;
        position: absolute;
        max-height: 300px;
        overflow: scroll;
        width: -webkit-fill-available;
        
    }
    .rep-list{
        border-bottom: solid .5px grey;
        z-index: 20;
        padding: 5px;
        &:hover {
            background-color: $ss-blue-light;
            color: black;
        }
    }
    .dropdown-background{
        position: fixed;
        min-width: 100%;
        min-height: 100%;
        z-index: 10;
        left: 0; 
        top: 0;
        }
    .form-group{
        margin-bottom: 0px;
        select {
            -webkit-appearance: none;
            -moz-appearance: none;
            -o-appearance: none;
            /* no standardized syntax available, no ie-friendly solution available */
        }
        select + i.fa {
            float: right;
            margin-top: -26px;
            margin-right: 5px;
            /* this is so when you click on the chevron, your click actually goes on the dropdown menu */
            pointer-events: none;
            background: inherit;
            /* everything after this is just to cover up the original arrow */
            /* (for browsers that don't support the syntax used above) */
            padding-right: 5px;
        }
    }
</style>
